export const DECK_TAB_INDEX = 'DECK_TAB_INDEX';
export const TEXTBOOK_TAB_INDEX = 'TEXTBOOK_TAB_INDEX';
export const FROM_DECK = 'FROM_DECK';
export const FROM_TEXTBOOK = 'FROM_TEXTBOOK';
